import { Temporal } from "@js-temporal/polyfill";
import { instantDateTime } from "@shared/schemas/common";

/** One scheduled recheck, never fixed-interval polling. Query timers stop when
 * unobserved; the existing focus lifecycle refreshes after a background pause. */
export function expiryRefreshDelay(nextExpiry: unknown, now = Date.now(), checkedAt?: string, receivedAt = now): number | false {
  if (!instantDateTime.safeParse(nextExpiry).success || !Number.isFinite(now)) return false;
  const expiry = Temporal.Instant.from(nextExpiry as string).epochMilliseconds;
  let remaining = expiry - now;
  if (instantDateTime.safeParse(checkedAt).success && Number.isFinite(receivedAt)) {
    // The browser clock can be ahead/behind the server. Start from the server's
    // remaining duration, then subtract elapsed client time since receipt.
    // A slow response stays conservative but never drops its scheduled recheck.
    const serverRemaining = expiry - Temporal.Instant.from(checkedAt!).epochMilliseconds;
    if (serverRemaining <= 0) return false;
    remaining = serverRemaining - Math.max(0, now - receivedAt);
  } else if (remaining < 0) return false; // No trusted basis for an old hint.
  // JS timers cap at signed 32-bit milliseconds. A very distant known expiry
  // gets a bounded recheck; never overflow into a tight one-millisecond loop.
  return Math.min(2_147_483_647, Math.max(1, remaining + 1));
}
